module.exports = angular.module('cartographer.app.form.string', [])

module.exports.factory 'crtStringFieldDirective', $DI (crtLog, $parse) ->
  # string (scope attrs -> (number -> number)) -> directive
  (directiveName, createAdjust) ->
    return {
      restrict: 'A'
      require: 'ngModel'
      link: ($scope, element, attrs, controllers) ->
        ngModel = controllers

        adjust = createAdjust($scope, attrs)

        parse = (inputValue) ->
          adjusted = adjust(inputValue)
          # crtLog.debug("#{directiveName}.parse", inputValue, adjusted)
          unless adjusted == inputValue
            ngModel.$setViewValue("" + adjusted)
            ngModel.$render()
          adjusted

        ngModel.$parsers.push(parse)

        parse($scope[attrs.ngModel])

        return
    }

module.exports.directive 'crtUpperCase', $DI ($parse, crtStringFieldDirective) ->
  crtStringFieldDirective 'crtUpperCase', ($scope, attrs) ->
    (inputValue) ->
      if typeof inputValue == 'string' then inputValue.toUpperCase() else inputValue

module.exports.directive 'crtLowerCase', $DI ($parse, crtStringFieldDirective) ->
  crtStringFieldDirective 'crtLowerCase', ($scope, attrs) ->
    (inputValue) ->
      if typeof inputValue == 'string' then inputValue.toLowerCase() else inputValue
